import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {BotatoChatManagerService, BotatoWidgetManagerService} from 'botato-angular-lib';
import {LIB_AUTH_SERVICE_TOKEN, LibAuthService} from './libAuthService.js';
import {TAB_NAVIGATION_SERVICE, TabNavigationService} from '../../services/TabNavigationService.js';
import {ChatNewMessageIndicatorService} from '../../services/ChatNewMessageIndicatorService.js';

@Injectable({
    providedIn: 'root'
})
export class ChatStartService {

    public isWaitingForNotification: boolean = false;
    public hasBeenOpened = new BehaviorSubject(false);

    constructor(private chatManager: BotatoChatManagerService,
                private widgetManager: BotatoWidgetManagerService,
                @Inject(TAB_NAVIGATION_SERVICE) private navigationService: TabNavigationService,
                @Inject(LIB_AUTH_SERVICE_TOKEN) private authService: LibAuthService,
                private chatNewMessageIndicatorService: ChatNewMessageIndicatorService) {

        this.chatManager.messageReceived$.subscribe(() => {
            if (this.navigationService.isChatTabActive()) {
                void this.chatManager.sendMarkAsRead();
            } else {
                this.chatNewMessageIndicatorService.show();
            }
        });

        this.chatManager.unreadStatus$.subscribe((hasUnread: boolean) => {
            if (hasUnread) {
                this.chatNewMessageIndicatorService.show();
            } else {
                this.chatNewMessageIndicatorService.reset();
            }
        });
    }

    public setOpenState(state: boolean): void {
        this.hasBeenOpened.next(state);
    }

    public getOpenState(): boolean {
        return this.hasBeenOpened.value;
    }

    public start(): void {
        this.authService.authentication$
            .subscribe(() => {
                    if (!this.isWaitingForNotification) {
                        if (!this.getOpenState()) {
                            this.setOpenState(true);
                            if (!this.chatManager.isAlreadyConnectedOnOtherClient()) {
                                void this.chatManager.start();
                            }
                        }
                    }
                }
            );

        this.chatManager.conversationHasHistory$.subscribe((hasHistory: boolean) => {
            if (hasHistory && this.navigationService.isChatTabActive()) {
                void this.chatManager.sendMarkAsRead();
            }
        });
    }
}
